module.exports = __webpack_public_path__ + "static/media/p4s.668146f4.webp";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/p4s.webp
// module id = 271
// module chunks = 0